import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=aff6e31e&scoped=true"
import script from "./Node.vue?vue&type=script&lang=js"
export * from "./Node.vue?vue&type=script&lang=js"
import style0 from "./Node.vue?vue&type=style&index=0&id=aff6e31e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff6e31e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aff6e31e')) {
      api.createRecord('aff6e31e', component.options)
    } else {
      api.reload('aff6e31e', component.options)
    }
    module.hot.accept("./Node.vue?vue&type=template&id=aff6e31e&scoped=true", function () {
      api.rerender('aff6e31e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleFlow/src/components/Node.vue"
export default component.exports